// REST-опрос статуса агента. Активен только для реального бэкенда
// (в мок-режиме статус приходит через события сессии). Полученный статус
// прокидывается наверх тем же сеттером, что и WS-статус.

import { useEffect } from 'react'
import { config } from '../config'
import { startAgentStatusPolling } from '../net/agentStatus'
import type { AgentStatus } from '../types'

export function useAgentStatusPolling(setStatus: (s: AgentStatus) => void): void {
  useEffect(() => {
    // Статус по REST опрашиваем только для стрим-бэкенда (ws). В режимах
    // mock и bridge статус приходит инлайн через события сессии.
    if (config.backend !== 'ws') return
    const stop = startAgentStatusPolling(
      (s) => setStatus(s),
      () => setStatus({ state: 'unknown', task: 'нет связи со статусом', updatedAt: Date.now() }),
    )
    return stop
  }, [setStatus])
}
